"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadDocumentIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class UploadDocumentIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 48 64", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", transform: "translate(-262.000000, -863.000000)" },
                React.createElement("g", { transform: "translate(262.000000, 863.000000)" },
                    React.createElement("g", null,
                        React.createElement("path", { d: "M0,3.84 C0,1.719 1.719,0 3.84,0 L32,0 L48,13.44 L48,60.16 C48,62.28 46.281,64 44.16,64 L3.84,64 C1.719,64 0,62.28 0,60.16 L0,3.84 Z M30.7030463,30.5718367 C31.2601693,30.0147138 31.2601693,29.1090318 30.7030463,28.5519089 L24.5718367,22.4178422 C24.0118567,21.8607193 23.1090318,21.8607193 22.5490518,22.4178422 L16.4178422,28.5519089 C15.8607193,29.1090318 15.8607193,30.0147138 16.4178422,30.5718367 C16.9749652,31.1289597 17.8806471,31.1289597 18.4377701,30.5718367 L22.1319239,26.8776829 L22.1319239,40.5714796 C22.1319239,41.3600229 22.771901,42 23.5604443,42 C24.3489875,42 24.9889647,41.3600229 24.9889647,40.5714796 L24.9889647,26.8776829 L28.6831185,30.5718367 C29.2402414,31.1289597 30.1459234,31.1289597 30.7030463,30.5718367 Z", fill: fill }),
                        React.createElement("path", { d: "M32,0 L32,9.6 C32,11.721 33.719,13.44 35.84,13.44 L48,13.44", fill: "#C1C6D2" }))))));
    }
}
exports.UploadDocumentIcon = UploadDocumentIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/upload-document.tsx
// module id = 2174
// module chunks = 0 1 2